import expandedMenuIcon from '../images/expanded-menu-icon.svg'
import dwpLightLogo from '../images/DWP-light.png'
import { RoutePath } from '../../../constants'
import NavMenuItem from './NavMenuItem'
import FirstRepairLogo from '../images/FR_logo_white.png'

interface MobileMenuProps {
  onNavigate: (path: string) => void
  onIsMenuOpenChange: (state: boolean) => void
}

function DesktopMenu({ onNavigate, onIsMenuOpenChange }: MobileMenuProps) {
  return (
    <div className="fixed h-fit bg-green z-[110] w-screen top-0 left-0">
      <div className="flex flex-row pl-8 pr-32 pt-8 pb-16">
        <div className="flex flex-col gap-8 flex-1">
          <div className="flex flex-row justify-between items-center">
            <div className="flex flex-row items-center">
              <img
                alt="Circles with FirstRepair below"
                className="max-w-[160px] h-auto align-middle border-none w-[90%]"
                src={FirstRepairLogo}
              />
              <img
                src={dwpLightLogo}
                className="pl-6 w-[182px] h-auto"
                alt="Decolonizing Wealth Project"
              />
            </div>
            <button
              type="button"
              onClick={() => onIsMenuOpenChange(false)}
              className="flex flex-row items-center"
            >
              <img src={expandedMenuIcon} alt="Single line" />
              <span
                className={
                  'font-decimal text-[16px] font-bold pl-3 text-white tracking-[.96px]'
                }
              >
                MENU
              </span>
            </button>
          </div>
          <div className="w-full justify-end flex">
            <div className="flex flex-col gap-8 w-[443px]">
              <NavMenuItem label="Home" onNavigate={() => onNavigate('/')} />
              <NavMenuItem
                label="Map"
                onNavigate={() => onNavigate(RoutePath.Map)}
              />
              <NavMenuItem
                label="Table"
                onNavigate={() => onNavigate(RoutePath.Table)}
              />
              <NavMenuItem
                label="About"
                onNavigate={() => onNavigate(RoutePath.About)}
              />
              <NavMenuItem
                label="+ Organization"
                onNavigate={() => onNavigate(RoutePath.AddOrganization)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DesktopMenu
